

import { Check } from "lucide-react";
import PricingButton from "../PricingButton";
import { PricingConfigType } from "@/hooks/subscription/types";

interface PremiumPlanCardProps {
  features: string[];
  billingPeriod: "monthly" | "yearly";
  handleGetStarted: () => void;
  pricingConfig: PricingConfigType;
}

const PremiumPlanCard = ({
  features,
  billingPeriod,
  handleGetStarted,
  pricingConfig
}: PremiumPlanCardProps) => {
  const isYearly = billingPeriod === "yearly";

  // Calculate price display - show monthly equivalent for annual like subscription page
  const price = isYearly
    ? `$${(pricingConfig.annual.amount / 100 / 12).toFixed(2)}`
    : pricingConfig.monthly.formattedPrice;

  // Calculate billing text
  const billingText = isYearly
    ? `per month, billed annually (${pricingConfig.annual.formattedPrice}/year)`
    : "/month";

  const savingsPercentage = pricingConfig.annual.savingsPercentage;

  return (
    <div className="bg-white rounded-lg shadow-lg border-2 border-primary overflow-hidden h-full flex flex-col relative transform md:scale-105 scale-100">
      {/* Most Popular Badge */}
      <div className="absolute top-0 left-0 right-0 bg-primary text-white py-1 text-center text-xs sm:text-sm font-medium">
        Most Popular
      </div>
      <div className="p-5 sm:p-6 pt-10 sm:pt-12 flex-grow">
        <h3 className="text-lg sm:text-xl font-bold">Premium</h3>
        <p className="text-neutral-600 text-xs sm:text-sm mt-1">For professionals</p>
        
        <div className="mt-4 sm:mt-6 mb-2">
          <span className="text-2xl sm:text-3xl font-bold">
            {price}
          </span>
          <span className="text-neutral-500 text-xs sm:text-sm ml-1">
            {isYearly ? "" : "/month"}
          </span>
        </div>
        {isYearly && (
          <div className="text-xs sm:text-sm text-neutral-600 mb-2">
            {billingText}
          </div>
        )}
        {isYearly && (
          <p className="text-xs sm:text-sm text-green-600">
            Save {savingsPercentage}% compared to monthly
          </p>
        )}
        
        <div className="mt-4 sm:mt-6 mb-3">
          <p className="font-medium text-sm sm:text-base">Everything in Free, and:</p>
        </div>
        
        <div className="space-y-3">
          {features.slice(4).map(feature => (
            <div key={feature} className="flex items-start">
              <div className="flex-shrink-0 mt-0.5">
                <Check className="h-4 w-4 sm:h-5 sm:w-5 text-green-500" />
              </div>
              <p className="ml-2 sm:ml-3 text-sm sm:text-base text-neutral-700 text-left">{feature}</p>
            </div>
          ))}
        </div>
        
        <p className="text-xs sm:text-sm text-neutral-600 mt-4 sm:mt-6 italic">
          (You'll know when it's time — until then, take your time.)
        </p>
      </div>
      
      <div className="px-5 sm:px-8 pb-5 sm:pb-8">
        <PricingButton onClick={handleGetStarted} variant="primary" />
      </div>
    </div>
  );
};

export default PremiumPlanCard;
